import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { pageHead } from "../seo";

// Every tag pageHead can return. They're swapped out as a set on each
// navigation, so tags only some pages have (prices, canonical) don't linger.
const PAGE_TAGS = [
    'meta[name="description"]',
    'meta[name="keywords"]',
    'meta[name="robots"]',
    'meta[name^="twitter:"]',
    'meta[property^="og:"]',
    'meta[property^="product:"]',
    'link[rel="canonical"]',
    'link[rel="alternate"][hreflang]',
    "script[data-page]",
].join(",");

// Keeps the tab title, language and <head> tags in step with the page.
export default function usePageMeta() {
    const { pathname } = useLocation();

    useEffect(() => {
        const { lang, title, tags } = pageHead(pathname);
        document.title = title;
        document.documentElement.lang = lang;

        document.head.querySelectorAll(PAGE_TAGS).forEach((element) => element.remove());
        tags.forEach(({ tag, attrs, text }) => {
            const element = document.createElement(tag);
            Object.entries(attrs).forEach(([name, value]) => element.setAttribute(name, value));
            if (text) element.textContent = text;
            document.head.appendChild(element);
        });
    }, [pathname]);
}
